<app-header></app-header>
<section class="container-fluid mb-5">
  <div class="initiale_sestion">
    <div class="dFlex">
      <div class="head" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1500">
        <h4 class="form-title-sm">{{'Profile' | translate}}</h4>
      </div>
    </div>
  </div>
  <div class="profile_dash container-fluid">
    <div class="grid-col grid-col-mobile-unset">
      <div class="col_1 bgStyle container-fluid " data-aos="fade-down" data-aos-delay="100" data-aos-duration="1500">
        <section class="stickySidebar">
          <div class="details">
            <!-- <figure>
              <ng-container *ngIf="!employee">
                <img src="{{accountDetails.company_logo}}" alt="company logo" class="img-fluid">
              </ng-container>
              <ng-container *ngIf="employee" >
                <img *ngIf="employee && accountDetails.image_url" src="{{ accountDetails.image_url }}" alt="profile pic" class="img-fluid">
                <img *ngIf="employee && !accountDetails.image_url" src="assets/images/default_user.png" alt="" class="img-fluid">
              </ng-container>
              <figcaption>
                <h3 *ngIf="!employee">Baywing Pvt Ltd</h3>
                <h3 *ngIf="employee">Ronin Malof</h3>
                <i class="fa-solid fa-pen-to-square"></i>
              </figcaption>
            </figure> -->
            <button class="profile-dp" *ngIf="employee && accountDetails.image_url">
              <label for="profilePhoto">
                <i class="fa-solid fa-pen-to-square"></i>
              </label>
              <input formControlName="imageFile" class="input_all" id="profilePhoto" type="file" data-target="profilePhoto" (change)="uploadDp($event, 'profile_dp_upload')">
            </button>
            <h4 *ngIf="!employee" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1500">{{
              accountDetails.company_name }}</h4>
            <h4 *ngIf="employee" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1500">{{
              accountDetails.first_name }} {{ accountDetails.last_name }}</h4>
            <!-- <h6 class="colour1" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1500">{{'Company' | translate}} : Baywing Pvt Ltd</h6> -->
            <h6 data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1500">+241 {{ accountDetails.mobile }}</h6>
          </div>
          <div class="sideOptions">
            <div class="sidemenu " [ngClass]="{'enabled': !bankDetails && !buinessList}" (click)="open('sidenav1')">
              <span>{{'General' | translate}}</span>
            </div>
            <div class="sidemenu" data-toggle="modal" data-target="#signinModal">{{'Change Password' | translate}}</div>
            <div *ngIf="!employee" class="routeBusinessList" (click)="open('sidenav4')" class="sidemenu" [ngClass]="{'enabled': buinessList && !bankDetails}">{{'Business Details' | translate}}</div>
            <!-- <div *ngIf="!employee" class="sidemenu" class="sidenav3" (click)="open('sidenav3');" [ngClass]="{'enabled': bankDetails &&!buinessList}"><span>{{'Bank Details' | translate}}</span></div> -->
            <div (click)="logout()">{{'Logout' | translate}}</div>
          </div>
        </section>
      </div>
      <div class="container-fluid  col_2 bgStyle" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1500" *ngIf="!bankDetails && !buinessList">
        <h2>{{'Profile Details' | translate }}</h2>
        <div class="currentStatus" data-aos="zoom-out" data-aos-delay="500" data-aos-duration="1500">
          <div class="table">
            <div class="td_1">
              <div *ngIf="employee" class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'CCPS ID' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 *ngIf="employee" class="text-md">{{accountDetails.ccps_code}}</h5>
                  <h5 *ngIf="!employee" class="text-md">{{accountDetails.ccps_id}}</h5>
                </div>
              </div>
              <!--     <div class="row line">
                <div class="col-md-4 col-4">
                  <h6 *ngIf="employee" class="label-txt">{{'Employee ID' | translate}}</h6>
                  <h6 *ngIf="!employee" class="label-txt">{{'Employer ID' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 *ngIf="employee" class="text-md">{{ accountDetails.employee_id }}</h5>
                  <h5 *ngIf="!employee" class="text-md">{{ accountDetails.employer_id }}</h5>
                </div>
              </div> -->
              <div *ngIf="!employee" class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'First name' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 class="text-md">{{ accountDetails.first_name }}</h5>
                </div>
              </div>
              <div *ngIf="!employee" class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'Last name' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 class="text-md">{{ accountDetails.last_name }}</h5>
                </div>
              </div>
              <div class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'CNAMGS ID' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 *ngIf="employee" class="text-md">{{ accountDetails.cnamgs }}</h5>
                  <h5 *ngIf="!employee" class="text-md">{{ accountDetails.cnamgs_id }}</h5>
                </div>
              </div>
              <div class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'CNSS ID' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 *ngIf="employee" class="text-md">{{ accountDetails.cnss}}</h5>
                  <h5 *ngIf="!employee" class="text-md">{{ accountDetails.cnss_id }}</h5>
                </div>
              </div>
              <!-- <div class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt text-capital">{{'Address' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 class="text-md">{{ accountDetails.address }}</h5>
                </div>
              </div> -->
              <div class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'Registered' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 *ngIf="employee" class="text-md">{{ accountDetails.join_date }}</h5>
                  <h5 *ngIf="!employee" class="text-md">{{ accountDetails.registered }}</h5>
                </div>
              </div>
              <div class="row line">
                <div class="col-md-4 col-4">
                  <h6 class="label-txt">{{'Email Id' | translate}}</h6>
                </div>
                <div class="col-md-8 col-8">
                  <h5 *ngIf="employee" class="text-md">{{accountDetails.email}}</h5>
                  <h5 *ngIf="!employee" class="text-md">{{accountDetails.email}}</h5>
                </div>
              </div>
              <!-- <div class="row line">
                <div *ngIf="!employee && accountDetails.cnss != 0 " class="col-md-6">
                  <div class="card-export">
                    <a href="{{accountDetails.cnss_url}}" target="_blank">
                      <div class="image_shadow cursor_pointor">
                        <div class="pdf-container"><img src="/assets/images/cnsspdf.png" class="img-fluid"></div>
                      </div>
                      <h6 class="label-txt">{{'Approved CNSS form Can be downloaded from below' | translate}}</h6>
                      <button class="btn-medium">{{'Download' | translate}}</button>
                    </a>
                  </div>
                </div>
                <div *ngIf="!employee && accountDetails.cnamgs != 0" class="col-md-6">
                  <div class="card-export">
                    <a href="{{accountDetails.cnamgs_url}}" target="_blank">
                      <div class="image_shadow cursor_pointor pdf-container">
                        <div class="pdf-container"><img src="/assets/images/cnamgspdf.png" class="img-fluid">
                        </div>
                      </div>
                      <h6 class="label-txt">{{'Approved CNAMGS form Can be downloaded from below' | translate}}</h6>
                      <button class="btn-medium">{{'Download' | translate}}</button>
                    </a>
                  </div>
                </div>
                <div *ngIf="employee && accountDetails.cnamgs != 0" class="col-md-12 cnss-form">
                  <div class="card-export">
                    <a href="{{accountDetails.cnss_pdf}}" target="_blank">
                      <div class="image_shadow cursor_pointor pdf-container">
                        <div class="pdf-container"><img src="/assets/images/cnsspdf.png" class="img-fluid">
                        </div>
                      </div>
                      <h6 class="label-txt">{{'Download CNSS form' | translate}}</h6>
                      <button class="btn-medium">{{'Download' | translate}}</button>
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="container-fluid  col_2 bgStyle ng-star-inserted aos-init aos-animate" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1500" *ngIf="buinessList && !bankDetails">
        <app-business-list></app-business-list>
      </div> -->
      <div class="container-fluid  col_2 bgStyle profile_bank_section profile_page" *ngIf="accountDetails.GNI == '1' && bankDetails " data-aos="fade-right" data-aos-delay="100" data-aos-duration="1500">
        <div class="company-details-section">
          <div id="bank-money-Section container-fluid">
            <div class="initiale_sestion">
              <div class="dFlex">
                <div class="head" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1500">
                  <h4> <i (click)="goBackbutton()" class="fa-solid fa-angle-left" *ngIf="openBankdetails"></i></h4>
                  <h4 class="form-title-sm title_bank_details">{{'Bank Details' | translate}}</h4>
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="container" id="bank_section">
              <div class="row" *ngIf="!showBankDetails">
                <div class="col-md-12 mt-3">
                  <!-- <label class="bankaccount"> {{'Select Bank'| translate}}</label> -->
                  <div class="row addButton" *ngIf="!showBankDetails">
                    <div class="text-container">
                      <div class="custom-container">
                        <i class="fa-solid fa-plus" (click)="showBankdetails()"><span>{{'Add Bank' | translate}}</span></i>
                      </div>
                    </div>
                  </div>
                  <div class="bankCardDiv">
                    <div class="bank-card" *ngFor="let bank of bankDatalist; let i = index">
                      <div class="row">
                        <div class="col-md-6 cardSection">
                          <label for="bank{{ bank.id }}">
                            <img src="{{ bank.bank_log }}">
                          </label>
                          <!-- <div class="card-child" *ngIf="bank.bank_type == 1">
                            <label for="">{{'Account number'|translate}}&nbsp;:&nbsp;</label>
                            <h5 class="noMarginebottom">{{bank.account_number}}</h5>
                          </div> -->
                          <!-- <div class="card-child" *ngIf="bank.bank_type == 2">
                            <label for="">{{'Mobile Number'|translate}}&nbsp;:&nbsp;</label>
                            <h5 class="noMarginebottom">{{bank.account_number}}</h5>
                          </div> -->
                          <!-- <div class="card-child">
                            <label for="">{{'Dénomination sociale'|translate}}&nbsp;:&nbsp;</label>
                            <h5 class="noMarginebottom">{{bank.account_name}}</h5>
                          </div> -->
                          <div class="card-child">
                            <label for="">{{'Bank name'|translate}}&nbsp;:&nbsp;</label>
                            <h5 class="noMarginebottom">{{bank.bank_name}}</h5>
                          </div>
                        </div>
                        <div class="col-md-4 cardSection4">
                          <!-- <div class="card-child">
                            <ng-container *ngIf="bank?.bank_number">
                              <label for="">{{'Bank number'|translate}}&nbsp;:&nbsp;</label>
                              <h5 class="noMarginebottom">{{bank.bank_number}}</h5>
                            </ng-container>
                            <ng-container *ngIf="bank?.bank_counter">
                              <label for="">{{'Bank counter'|translate}}&nbsp;:&nbsp;</label>
                              <h5 class="noMarginebottom">{{bank.bank_counter}}</h5>
                            </ng-container>
                          </div> -->
                          <div class="custom-container" *ngIf="bank.bank_slip != null">
                            <a href="{{bank.bank_slip}}" target="_blank">
                              <label for="bank_ac_statement" class="file-upload-card labeltxt">
                                <div class="text-center insideViewinput">
                                  <i class="fa-solid fa-download" aria-hidden="true"></i>
                                  <label for="bank_ac_statement" class="labeltxt">{{'Bank account statement' | translate}}</label>
                                </div>
                              </label>
                            </a>
                          </div>
                        </div>
                        <div class="col-md-2 cardSection3">
                          <div class="text-danger deleteBankButton">
                            <div (click)="selectedBank(bank.id)"><i class="fa fa-trash" aria-hidden="true"></i></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="currentStatus" *ngIf="openBankdetails">
          <div class="row">
            <div class="col-md-12 mt-4 mb-4 text-center">
              <!-- <div class="row">
                <div class="col-md-12 mt-4 mb-4 addButton">
                  <button type="button" class="btn btn-main" (click)="goBackbutton()">{{'Go back' |translate}}</button>
                  
                </div>
              </div> -->
              <div id="tab-parent">
                <div class="tabs">
                  <input type="radio" id="radio-1" name="tabs" checked />
                  <label class="tabq" for="radio-1">{{'Bank / Microfinance / Mobile Money'| translate}}</label>
                  <input type="radio" id="radio-2" name="tabs" />
                  <!-- <label class="tabq" for="radio-2" (click)="open('money')">{{'Mobile Money'| translate}}</label> -->
                  <span class="glider"></span>
                </div>
              </div>
            </div>
          </div>
          <form id="bankDetailsForm" *ngIf="bankDetails" [formGroup]="bankDetailsForm" (ngSubmit)="onSubmitBankForm()">
            <div class="line">
              <h4>{{'Bank Account Details'|translate}}</h4>
            </div>
            <div class="enroll_form">
              <div>
                <div class="input_section">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <label for=""> {{'Select Bank'| translate}}</label>
                        <div class="grid-parent">
                          <div class="grid-container">
                            <div class="grid-child" *ngFor="let bank of bankdata">
                              <input type="radio" id="bank{{ bank.bank_id }}" name="banks" formControlName="banks" value="{{ bank.bank_id }}" (change)="handleChange($event, bank.bank_name, bank.bank_id,bank.bank_type)">
                              <label for="bank{{ bank.bank_id }}">
                                <img src="{{ bank.bank_logo }}">
                              </label>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="isSubmitted && g.banks.errors" class="invalid-feedback">
                          <div *ngIf="g.banks.errors?.required">{{'Bank'|translate}} {{'is required'|translate}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <!-- <div class="col-md-6 mt-3">
                        <label *ngIf="bank" for="">{{'Account number'|translate}}</label>
                        <label *ngIf="!bank" for="">{{'Mobile number'|translate}}</label>
                        <input type="text" formControlName="account_number" [attr.maxlength]="bank ? 11 : 8">
                        <div *ngIf="!bank" class="text-sm textUnderMobile mt-2 ps-3">Note : {{'Mobile should start with valid numbers like 77, 76, 74, 66, 65, 62, 60, 61'|translate}}</div>
                        <div *ngIf="isSubmitted && bank && g.account_number.errors" class="invalid-feedback">
                          <div *ngIf="g.account_number.errors?.required">{{'Account number'|translate}} {{'is required'|translate}}</div>
                          <div *ngIf="g.account_number.errors?.pattern">{{'Account number'|translate}} {{'should be valid'|translate}}</div>
                        </div>
                        <div *ngIf="isSubmitted && !bank && g.account_number.errors" class="invalid-feedback">
                          <div *ngIf="g.account_number.errors?.required">{{'Mobile number'|translate}} {{'is required'|translate}}</div>
                          <div *ngIf="g.account_number.errors?.pattern">{{'Mobile number'|translate}} {{'should be valid'|translate}}</div>
                        </div>
                      </div>
                      <div class="col-md-6 mt-3">
                        <label for="">{{'Dénomination sociale'|translate}}</label>
                        <input type="text" formControlName="account_name" readonly [value]="setBankAccountName()">
                        <div *ngIf="isSubmitted && g.account_name.errors" class="invalid-feedback">
                          <div *ngIf="g.account_name.errors?.required">{{'Dénomination sociale'|translate}} {{'is required'|translate}}</div>
                          <div *ngIf="g.account_name.errors?.pattern">{{'Dénomination sociale'|translate}} {{'should be  valid'|translate}}</div>
                        </div>
                      </div>
                      <div class="col-md-6 mt-3">
                        <label for="">{{'Bank name'|translate}}</label>
                        <input type="text" readonly formControlName="bank_name">
                        <div *ngIf="isSubmitted && g.bank_name.errors" class="invalid-feedback">
                          <div *ngIf="g.bank_name.errors?.required">{{'Bank name'|translate}} {{'is required'|translate}}</div>
                          <div *ngIf="g.bank_name.errors?.pattern">{{'Bank name'|translate}} {{'should be valid'|translate}}</div>
                        </div>
                      </div>
                      <div class="col-md-6 mt-3" *ngIf="bank">
                        <label for="">{{'Bank number'|translate}}</label>
                        <input type="text" formControlName="bank_number" maxlength="10">
                        <div *ngIf="isSubmitted && g.bank_number.errors" class="invalid-feedback">
                          <div *ngIf="g.bank_number.errors?.required">{{'Bank number'|translate}} {{'is required'|translate}}</div>
                          <div *ngIf="g.bank_number.errors?.pattern">{{'Bank number'|translate}} {{'should be valid'|translate}}</div>
                        </div>
                      </div>
                      <div class="col-md-6 mt-3">
                        <label for="">{{'Bank counter'|translate}}</label>
                        <input type="text" formControlName="bank_counter" maxlength="20">
                        <div *ngIf="isSubmitted && g.bank_counter.errors" class="invalid-feedback">
                          <div *ngIf="g.bank_counter.errors?.required">{{'Bank counter'|translate}} {{'is required'|translate}}</div>
                          <div *ngIf="g.bank_counter.errors?.pattern">{{'Bank counter'|translate}} {{'should be valid'|translate}}</div>
                        </div>
                      </div> -->
                      <!-- Bank slip shown for every bank -->
                      <div class="col-md-12 col-lg-12 col-sm-12 mt-3 bankslip">
                        <label for="bank_slip" class="upload_bankText">{{'Upload Bank Slip'|translate}}<span class="text-danger">*</span><span *ngIf="bank_slip" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                        <label for="bank_slip" id="bank_slipUpload" class="file-upload-card bank_slipUpload">
                          <div class="custom-container">
                            <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                            <i class="fa fa-upload" aria-hidden="true"></i>
                          </div>
                        </label>
                        <div *ngIf="!bank_slip" class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                        <input class="input_hide" id="bank_slip" type="file" formControlName="imageFile" (change)="upload($event,'bank_slip_upload')" data-target="bank_slip">
                        <a *ngIf="bank_slip" id="bank_slip_upload" href="{{bank_slip}}" target="_blank" class="viewFile text-center">{{'Click to view File'| translate}}</a>
                        <div *ngIf="isSubmitted && g.bank_slip.errors" class="invalid-feedback d-block">
                          <div *ngIf="g.bank_slip.errors.required">{{'This field is mandatory'|translate}}.</div>
                          <div *ngIf="g.bank_slip.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 mt-4 mb-4 text-center">
                        <button type="submit" id="submit_btn" class="btn btn-main">{{'Save Changes' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="bankDatalist && bankDatalist.length <=0 && !openBankdetails" class="text-container no-list-container text-center">
          <div class="image-container col-sm-12">
            <img src="assets/images/employee_nolist.png">
          </div>
          <h3 class="mt-4">{{'No Banks added' | translate}}</h3>
        </div>
      </div>
      <div class="container-fluid  col_2 bgStyle" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1500" *ngIf="buinessList && !bankDetails">
        <div class="currentStatus" data-aos="zoom-out" data-aos-delay="500" data-aos-duration="1500">
          <app-business-list></app-business-list>
        </div>
      </div>
      <!-- <div class="col_2 bgStyle profile_bank_section profile_page" *ngIf="accountDetails.GNI == '0'"
        data-aos="fade-right" data-aos-delay="100" data-aos-duration="1500">
        <div class="parent">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <div class="image-container">
                <img src="assets/images/link_success.png" class="img-fluid">
              </div>
              <div class="text-container text-center mt-5">
                <h4 class="modal-header-txt">{{'Inorder to Continue' | translate}}</h4>
                <p class="para-light">{{'Please Import Business From GNI First' | translate }}</p>
              </div>
              <div class="button-container justify-content-center mt-4 d-flex">
                <button type="submit" id="submit_btn" class="btn btn-medium" routerLink="/link-business">{{'Import
                  Business' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</section>
<app-footer></app-footer>
<section class="modal-section">
  <div class="modal fade-scale" id="signinModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="modal-image-container">
            <!-- <h5 class="modal-title title-medium" id="exampleModalLongTitle">
              <div class="logo-div">
              <img src="assets/images/inner-logo.png" alt="">
            </div></h5> -->
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button> -->
          </div>
          <div id="signin" class="text-container">
            <h5 class="title-medium">{{'Change Password' | translate}}</h5>
            <!-- <p>{{'Login to your Account' | translate}}</p> -->
            <form class="form-container" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitResetPassword()">
              <div class="input-container">
                <div class="child-container">
                  <label class="labeltxt">{{'Current Password' | translate}}</label>
                  <div>
                    <input name="current_password" type="{{ passwordFieldType }}" formControlName="current_password">
                    <span class="eye-icon" (click)="eyeclose()"><i id="eye" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && f.current_password.errors" class="invalid-feedback">
                    <div *ngIf="f.current_password.errors?.required">{{'Current Password'|translate}} {{'is required'|translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'New Password' | translate}}</label>
                  <input type="{{ passwordFieldType }}" name="password" formControlName="password">
                  <div *ngIf="isSubmitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors?.required">{{'Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.password.errors.minlength">{{'Password must be at least 8 characters'|translate}}
                    </div>
                    <div *ngIf="f.password.errors?.pattern ">{{'password should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Confirm Password' | translate}}</label>
                  <input type="{{ passwordFieldType }}" name="confirm_Password" formControlName="confirmPassword">
                  <div *ngIf="isSubmitted && f.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="f.confirmPassword.errors?.required">{{'Confirm Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.confirmPassword.errors.ConfirmPassword">{{'New password and confirm password do not match' | translate}}</div>
                  </div>
                  <!-- <span class="eye-icon"><i class="fa fa-eye" aria-hidden="true"></i></span> -->
                </div>
              </div>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Save Password' | translate}}</button>
            </form>
            <!-- <p class="small-txt">{{'No Account' | translate}}? <button id="show-signup" (click)="showSignup()">{{'Sign Up' | translate}}</button></p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div id="permissionRejectModal" class="modal fade rejectcalculate" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <!-- Modal content-->
    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <div class="modal-body">
        <h5>{{'Do you want to delete this bank account ?' | translate}}</h5>
        <div class="buttonFlex">
          <button class="reject_color" data-dismiss="modal">{{'No' | translate}}</button>
          <button class="accept_color" (click)="deleteBank()">{{'Yes' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-contact-floating></app-contact-floating>
